import {
  Puzzle,
  Key,
  Users,
  Layout,
  Terminal,
  Layers,
  FileText,
  Edit3,
  Link2,
  Search,
  RefreshCw,
  Package,
  PackageCheck,
  Monitor,
  Code2
} from 'lucide-react';

/**
 * Navigation items for the admin sidebar
 * Each item maps to a dashboard component
 */
export const NAV_ITEMS = [
  { 
    id: 'plugins', 
    label: 'Plugins', 
    icon: Puzzle,
    description: 'Manage web applications'
  },
  { 
    id: 'credentials', 
    label: 'Credentials', 
    icon: Key,
    description: 'API keys and secrets'
  },
  { 
    id: 'permissions', 
    label: 'Permissions', 
    icon: Users,
    description: 'Groups and access control'
  },
  { 
    id: 'spaces', 
    label: 'Spaces', 
    icon: Layout,
    description: 'Tab configuration'
  },
  { 
    id: 'launchers', 
    label: 'Launchers', 
    icon: Terminal,
    description: 'DCC launcher management'
  },
  { 
    id: 'applications', 
    label: 'Applications', 
    icon: Monitor,
    description: 'DCC executable paths'
  },
  { 
    id: 'environments', 
    label: 'Environments', 
    icon: Layers,
    description: 'Environment variables'
  },
  { 
    id: 'pages', 
    label: 'Pages', 
    icon: FileText,
    description: 'Static page content'
  },
  { 
    id: 'blog', 
    label: 'Blog', 
    icon: Edit3,
    description: 'Blog posts'
  },
  { 
    id: 'redirects', 
    label: 'Redirects', 
    icon: Link2,
    description: 'URL redirects'
  },
  { 
    id: 'debug', 
    label: 'Debug State', 
    icon: Search,
    description: 'Review global state'
  },
  { 
    id: 'packages', 
    label: 'Package Repo', 
    icon: Package,
    description: 'Browse and install packages'
  },
  { 
    id: 'installed', 
    label: 'Installed Packages', 
    icon: PackageCheck,
    description: 'Manage installed packages'
  },
  { 
    id: 'sdk', 
    label: 'SDK', 
    icon: Code2,
    description: 'Development tools'
  }
];

/**
 * Action items (not navigation destinations)
 */
export const ACTION_ITEMS = [
  {
    id: 'sync',
    label: 'Sync Plugins',
    icon: RefreshCw,
    description: 'Trigger plugin synchronization'
  }
];

/**
 * Default section to show when panel opens
 */
export const DEFAULT_SECTION = 'plugins';

